import React from 'react';
import ContentManager from '../Content/ContentManager';

const RaffleAssetsManager = ({ raffleId }: { raffleId: string }) => {
  if (!raffleId) {
    return null;
  }

  return (
    <ContentManager
      allowedAssignmentTargetKeys={['raffle.media', 'raffle.ticket.image']}
      defaultAssignmentFilter={{
        scopeType: 'raffle',
        scopeId: raffleId,
      }}
      lockedAssignmentFilter
      defaultAssignmentScope={{
        scopeType: 'raffle',
        scopeId: raffleId,
      }}
      lockAssignmentScope
    />
  );
};

export default RaffleAssetsManager;
